export const INSTRUCTION_1 = '# 1. Install the Teamwork Graph CLI';
export const INSTRUCTION_2 = '# 2. Verify the installation';
export const VERIFY_INSTALLATION_COMMAND = 'twg --version';
export const INSTRUCTION_3 = '# 3. Authenticate';
export const AUTHENTICATE_COMMAND = 'twg login';
export const INSTRUCTION_4 = '# 4. Install skills';
export const INSTALL_SKILLS_COMMAND = 'twg skills install';
